document.addEventListener("DOMContentLoaded", function () {
  var emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  // Stage-one demo forms only (the placement's Customizer shortcode is empty):
  // fake validation and a fake success message. Nothing is sent anywhere.
  document.querySelectorAll(".js-newsletter-form").forEach(function (form) {
    var input = form.querySelector('input[type="email"]');
    var consent = form.querySelector('input[type="checkbox"]');
    var msg = form.querySelector("[data-newsletter-msg]");
    if (!input) return;

    function fail(text, field) {
      form.classList.remove("is-success");
      form.classList.add("is-error");
      if (msg) msg.textContent = text;
      if (field) {
        field.setAttribute("aria-invalid", "true");
        field.focus();
      }
    }

    form.addEventListener("submit", function (e) {
      e.preventDefault();

      var value = input.value.trim();
      form.classList.remove("is-success", "is-error");
      input.removeAttribute("aria-invalid");
      if (consent) consent.removeAttribute("aria-invalid");

      if (!emailPattern.test(value)) {
        fail(value ? "Please enter a valid email address." : "Please enter your email address.", input);
        return;
      }

      if (consent && !consent.checked) {
        fail("Please accept the Privacy Policy to subscribe.", consent);
        return;
      }

      form.classList.add("is-success");
      if (msg) msg.textContent = "Thank you! You are subscribed.";
      form.reset();
    });
  });
});
